<template>
  <section class="newTable" v-if="options">
    <table
      class="table datatable table-striped"
      :class="
        !options.color
          ? ''
          : options.color === 'green'
          ? 'insurance-green'
          : 'insurance-blue'
      "
      :id="prefix"
    >
      <thead>
        <tr>
          <th
            v-if="options.checkAll"
            :width="options.checkBoxHasUser ? 130 : 70"
          >
            <div class="checkbox checkbox-inline mr-0" v-if="multiple">
              <input
                @click="checkAllClick = true"
                type="checkbox"
                name="check-all"
                id="check-all"
                value="1"
                v-model="checkAll"
              />
              <label for="check-all"></label>
            </div>
            <span v-if="options.checkBoxHasUser">#</span>
          </th>
          <th
            v-for="(item, index) in options.columns"
            :key="`${prefix}-table-tr-${index}`"
            :width="
              (index + 1 === options.columns.length && options.scrollHeight
                ? is_iPad
                  ? item.width
                  : item.width + 17
                : item.width) || '*'
            "
            :class="
              item.sorting
                ? 'sorting ' +
                  (order.index == index + 1
                    ? order.asc
                      ? 'sorting_asc'
                      : 'sorting_desc'
                    : '')
                : ''
            "
            @click="item.sorting ? columnSorting(index + 1, item.name) : false"
          >
            <span v-html="item.label"></span>
          </th>
        </tr>
      </thead>
      <tbody
        @scroll="scrollmethod"
        v-if="tableData.length"
        :class="options.scrollHeight ? 'block-height' : ''"
        class="scrollBehavior"
        :style="{
          height:
            options.isMoreCnt || options.noScroll
              ? 'auto'
              : options.scrollHeight + 'px',
        }"
        ref="tbody"
      >
        <tr
          v-for="(d, did) in tableData.slice(
            0,
            options.isMoreCnt ? options.moreLength : tableData.length
          )"
          :key="`${prefix}-table-td-${did}`"
        >
          <td
            v-if="options.checkAll"
            :width="options.checkBoxHasUser ? 130 : 70"
            :height="d.vip_level ? 65 : 30"
          >
            <div class="d-flex flex-row" style="min-height: 30px">
              <div
                v-if="multiple"
                :style="{
                  opacity: checkboxEnabled(d) ? '1' : '0',
                }"
                class="mr-0 checkbox checkbox-inline"
              >
                <template v-if="options.checkList">
                  <input
                    @click="checkAllClick = false"
                    type="checkbox"
                    :name="`td-item${multiple ? '[]' : ''}`"
                    :id="`${prefix}-check-${did}`"
                    :value="d"
                    v-model="selectionData"
                    :disabled="!checkboxEnabled(d)"
                    @change="$emit('update', selectionData)"
                  />
                  <label :for="`${prefix}-check-${did}`"></label>
                </template>
                <template v-else>
                  <input
                    @click="checkAllClick = false"
                    type="checkbox"
                    :name="`td-item${multiple ? '[]' : ''}`"
                    :id="`${prefix}-check-${did}`"
                    :value="d.id || d.ser_no"
                    v-model="selectionData"
                    :disabled="!checkboxEnabled(d)"
                    @change="$emit('update', selectionData)"
                  />
                  <label :for="`${prefix}-check-${did}`"></label>
                </template>
              </div>
              <div v-else class="mr-0 radio radio-inline">
                <input
                  @click="checkAllClick = false"
                  type="radio"
                  :name="`td-item${multiple ? '[]' : ''}`"
                  :id="`${prefix}-check-${did}`"
                  :value="d.id || d.ser_no"
                  v-model="selectionData"
                  @change="$emit('update', selectionData)"
                />
                <label :for="`${prefix}-check-${did}`"></label>
              </div>

              <span
                v-if="options.checkBoxHasUser"
                class="flex-grow-1"
                style="margin: 5px 0px"
              >
                <span class="no">{{ did + 1 }}</span>
                <span class="info text-center">
                  <level :lv="Number(d.vip_level)" />
                  <avatar :gender="Number(d.sex)" :size="20" />
                </span>
              </span>
            </div>
          </td>
          <td
            v-for="(col, cid) in options.columns"
            :width="col.width || '*'"
            :key="`table-td-col-${cid}`"
          >
            <span v-if="col.slot">
              <slot v-if="reflash" :name="col.name" :item="d"></slot>
            </span>
            <span
              v-else-if="col.template"
              v-html="col.template(d[col.name])"
            ></span>
            <span v-else-if="col.name === 'birthday'">
              <!-- 20210623 資料遮蔽 -->
              <div class="date" v-if="isMask">
                {{ d[col.name] | dateFormat | getMaskBirthday }}
              </div>
              <div class="date" v-else>{{ d[col.name] | dateFormat }}</div>
              <div v-if="!options.showAge" class="age">
                <!--<span v-if="!d.age || d.age == '0'">— —</span>-->
                <span v-if="d.age == '0'"><b>0歲</b></span>
                <span v-else-if="d.age">
                  <b>{{ d.age }}歲</b>
                </span>
                <span v-else><b>— —</b></span>
              </div>
            </span>
            <span v-else-if="col.name === 'age'">
              <div class="age">
                <!--<span v-if="!d.age || d.age == '0'">— —</span>-->
                <span v-if="d.age == '0'">0</span>
                <span v-else-if="d.age">{{ d.age }}</span>
                <span v-else>
                  {{ birthday2age(d) }}
                </span>
              </div>
            </span>
            <span v-else-if="col.name === 'idmark'">
              <div class="list inline">
                <span
                  class="tag-box"
                  :class="d[col.name].indexOf('1') > -1 ? 'active' : ''"
                >
                  要
                </span>
                <span
                  class="tag-box"
                  :class="d[col.name].indexOf('2') > -1 ? 'active' : ''"
                >
                  被
                </span>
                <span
                  class="tag-box"
                  :class="d[col.name].indexOf('3') > -1 ? 'active' : ''"
                >
                  意
                </span>
                <span
                  class="tag-box"
                  :class="d[col.name].indexOf('4') > -1 ? 'active' : ''"
                >
                  產
                </span>
                <span
                  class="tag-box"
                  :class="d[col.name].indexOf('5') > -1 ? 'active' : ''"
                >
                  團
                </span>
                <span
                  class="tag-box"
                  :class="d[col.name].indexOf('6') > -1 ? 'active' : ''"
                >
                  借
                </span>
              </div>
            </span>
            <span v-else-if="col.name === 'visit'">
              <button
                class="btn btn-primary"
                style="font-size: 12px"
                v-html="d[col.name]"
              ></button>
            </span>
            <span v-else-if="col.name === 'letter'">
              <a
                @click="col.click(d, d['letter'][0].type)"
                class="link line-height-2 text-underline"
              >
                親送專函
              </a>
              <br />
              <a
                @click="col.click(d, d['letter'][1].type)"
                class="link line-height-2 text-underline"
              >
                郵寄專函
              </a>
            </span>
            <template v-else-if="col.name === 'search'">
              <a
                v-if="d['id'] && d['havePolicy']"
                @click="colClick(col, d, did)"
                class="link text-underline"
              >
                查詢
              </a>
              <span v-else>— —</span>
            </template>
            <a
              v-else-if="col.click && isMask"
              @click="colClick(col, d, did)"
              class="link text-underline"
            >
              <!-- 20210623 資料遮蔽 -->
              <Tooltip
                :position="did < 4 ? 'bottom' : 'top'"
                :valMap="{
                  name: d.name,
                  showid: d.showid,
                  mobile: d.mobile,
                  phone: d.phone,
                  birthday: d.birthday,
                  address: d.address,
                  family_name: d.family_name,
                }"
                :allType="options.columns"
              >
                <a
                  @click="colClick(col, d, did)"
                  class="link text-underline"
                  title=""
                  >{{ d[col.name] | getMaskName }}</a
                >
              </Tooltip>
            </a>
            <a
              v-else-if="col.click && !isMask"
              @click="colClick(col, d, did)"
              class="link text-underline"
            >
              <!-- 20210623 資料遮蔽 -->
              <a
                @click="colClick(col, d, did)"
                class="link text-underline"
                title=""
                >{{ d[col.name] }}</a
              >
            </a>
            <!-- 20210623 資料遮蔽 -->
            <span v-else-if="col.name === 'showid' && isMask">{{
              d[col.name] | getMaskID
            }}</span>
            <span v-else-if="col.name === 'showid' && !isMask">{{
              d[col.name]
            }}</span>
            <span v-else-if="col.name === 'mobile' && isMask">{{
              d[col.name] | getMaskMobile
            }}</span>
            <span v-else-if="col.name === 'mobile' && !isMask">{{
              d[col.name]
            }}</span>
            <span v-else-if="col.name === 'phone' && isMask">{{
              d[col.name] | getMaskPhone
            }}</span>
            <span v-else-if="col.name === 'phone' && !isMask">{{
              d[col.name]
            }}</span>
            <span v-else-if="col.name === 'address' && isMask">{{
              d[col.name] | getMaskAddress
            }}</span>
            <span v-else-if="col.name === 'address' && !isMask">{{
              d[col.name]
            }}</span>
            <span v-else>{{ d[col.name] }}</span>
          </td>
        </tr>
        <tr v-if="scrollMessageLoading">
          <td colspan="8" class="text-center pt-3 pb-5">
            <h3>
              <div
                class="section-loading d-inline-block"
                style="height: 20px; width: 30px"
              ></div>
              資料載入中
              <span>. . .</span>
            </h3>
          </td>
          <td style="display: none"></td>
          <td style="display: none"></td>
          <td style="display: none"></td>
          <td style="display: none"></td>
          <td style="display: none"></td>
          <td style="display: none"></td>
          <td style="display: none"></td>
        </tr>
        <!-- More -->
        <tr v-if="options.isMoreCnt && tableData.length > options.isMoreCnt">
          <td
            :colspan="tdCount"
            style="
              text-align: center;
              line-height: 25px;
              cursor: pointer;
              background-color: white;
            "
            @click="showMore()"
          >
            <template v-if="is_more">
              <span
                style="
                  color: rgb(0, 170, 66);
                  font-weight: bold;
                  text-decoration: underline;
                "
              >
                顯示更多
              </span>
              <span style="color: rgb(0, 170, 66)">
                <i class="icon-collapse_down"></i>
              </span>
            </template>
            <template v-else>
              <span
                style="
                  color: rgb(0, 170, 66);
                  font-weight: bold;
                  text-decoration: underline;
                "
              >
                收合顯示
              </span>
              <span style="color: rgb(0, 170, 66)">
                <i class="icon-collapse_up"></i>
              </span>
            </template>
          </td>
        </tr>
        <!-- /More -->
      </tbody>
      <tbody v-else>
        <tr v-if="dataLoading">
          <td colspan="8" class="text-center pt-3 pb-5">
            <h3>
              <div
                class="section-loading d-inline-block"
                style="height: 20px; width: 30px"
              ></div>
              資料載入中
              <span>. . .</span>
            </h3>
          </td>
          <td style="display: none"></td>
          <td style="display: none"></td>
          <td style="display: none"></td>
          <td style="display: none"></td>
          <td style="display: none"></td>
          <td style="display: none"></td>
          <td style="display: none"></td>
        </tr>
        <tr v-else>
          <td colspan="8" class="empty-block">
            <h3>
              <div
                v-if="
                  !remoteDataMsg.includes('查無資料') &&
                  !remoteDataMsg.includes('完成') &&
                  !remoteDataMsg.includes('尚未')
                "
                class="section-loading d-inline-block"
                style="height: 20px; width: 30px"
              ></div>
              {{ remoteDataMsg }}
            </h3>
          </td>
          <td style="display: none"></td>
          <td style="display: none"></td>
          <td style="display: none"></td>
          <td style="display: none"></td>
          <td style="display: none"></td>
          <td style="display: none"></td>
          <td style="display: none"></td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import { computeAge } from "@/service/index";
import Level from "../Level";
import Avatar from "../Avatar";
import { mapMutations, mapGetters } from "vuex";

import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";
import Tooltip from "@/desktop/components/ToolTipMv";

export default {
  name: "DataTable",
  mixins: [commonMixin],
  components: { Level, Avatar, Tooltip },
  props: {
    multiple: {
      type: Boolean,
      default: true,
    },
    prefix: {
      type: String,
      default: "",
    },
    remoteDataMsg: {
      type: String,
      default: "",
    },
    currentPage: {
      type: Number,
      default: 0,
    },
    totalpages: {
      type: Number,
      default: 0,
    },
    scrollDataLoading: {
      type: Boolean,
      default: false,
    },
    scrollMessageLoading: {
      type: Boolean,
      default: false,
    },
    selection: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    options: {
      type: Object,
      default: () => {
        return null;
      },
    },
    addPageStatus: {
      type: Boolean,
      default: false,
    },
    tableType: {
      type: String,
      default: "default",
    },
    initSort: {
      type: Boolean,
      default: false,
    },
    isMask: {
      type: Boolean,
      default: false,
    },
    dataLoading: {
      type: Boolean,
      default: false,
    },
    saveData: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checkFirst: true,
      tableList: this.tableData,
      is_more: true, //顯示更多
      order: {
        index_default: 0,
        asc_default: true,
        index: 0,
        asc: true,
      },
      checkAll: false,
      selectionData: [],
      currentWidth: 0,
      nowTime: 0,
      lastTime: 0,
      checkAllClick: false,
      reflash: true,
      iPadWidth: this.is_iPad ? 100 : 117,
    };
  },
  watch: {
    tableData: "initData",
    checkAll: function (val) {
      if (val && this.checkAllClick) {
        // this.selectionData = [];

        if (this.options.checkList) {
          if (this.selectionData && this.selectionData.length > 0) {
            let ids = new Set(this.selectionData.map((d) => d.id));
            let sers = new Set(this.selectionData.map((d) => d.ser_no));
            this.selectionData = [
              ...this.selectionData,
              ...this.tableData.filter((d) => {
                if (!this.checkboxEnabled(d)) {
                  return false;
                }

                if (d.ser_no) {
                  if (!sers.has(d.ser_no)) {
                    return true;
                  } else {
                    return false;
                  }
                } else {
                  if (!ids.has(d.id)) {
                    return true;
                  } else {
                    return false;
                  }
                }
              }),
            ];
          } else {
            this.selectionData = JSON.parse(
              JSON.stringify(this.tableData)
            ).filter((d) => {
              return this.checkboxEnabled(d);
            });
          }
        } else {
          this.tableData.forEach((data) => {
            if (data.id !== "" || data.ser_no !== "") {
              this.selectionData.push(data.id || data.ser_no);
            }
          });
        }
        this.$emit("update", this.selectionData);
      } else if (this.checkAllClick) {
        if (!this.addPageStatus) {
          this.selectionData = this.selectionData.filter((item) => {
            let chk = true;
            this.tableData.forEach((itemI) => {
              if (this.checkboxEnabled(itemI)) {
                if (item.ser_no) {
                  if (itemI.ser_no == item.ser_no) {
                    chk = false;
                  }
                } else {
                  if (itemI.c111_id == item.c111_id) {
                    chk = false;
                  }
                }
              }
            });
            return chk;
          });
          // this.selectionData = [];
        }
        this.$emit("update", this.selectionData);
      }

      this.$emit("updateall", this.checkAll);
    },
    selection: function () {
      this.selectionData = this.selection;
      if (!this.selectionData.length) {
        this.checkAll = false;
      } else if (
        this.tableData.filter((item) => {
          return this.checkboxEnabled(item);
        }).length !== this.selectionData.length &&
        !this.checkAllClick
      ) {
        this.checkAll = false;
      } else if (!this.checkAllClick) {
        this.checkAll = true;
      }
    },
  },
  methods: {
    ...mapMutations(["updateSavePageData"]),
    initData() {
      // if (this.tableData.length != this.selectionData.length) {
      //   this.selectionData = this.selection;
      // }
      if (
        this.tableData.filter((item) => {
          return this.checkboxEnabled(item);
        }).length !== this.selectionData.length
      ) {
        this.checkAll = false;
      } else {
        this.checkAll = this.reChkAllData(this.tableData, this.selectionData);
      }

      if (this.initSort) {
        this.order.index = this.order.index_default;
        this.order.asc = this.order.asc_default;
      }

      if (!this.selectionData.length) {
        this.checkAll = false;
      } else if (
        this.tableData.filter((item) => {
          return this.checkboxEnabled(item);
        }).length !== this.selectionData.length &&
        !this.checkAllClick
      ) {
        this.checkAll = false;
      } else if (!this.checkAllClick) {
        this.checkAll = this.reChkAllData(this.tableData, this.selectionData);
      }

      if (!this.addPageStatus && !this.options.checkList) {
        this.selectionData = [];
      }
      if (this.selectionData.length) {
        this.$emit("update", this.selectionData);
      }

      if (this.checkFirst == true) {
        this.checkFirst = false;

        if (this.options.defaultSort) {
          let indexO = 0;
          let asc =
            this.options.defaultSort.asc === false
              ? (asc = this.options.defaultSort.asc)
              : true;

          for (let index = 0; index < this.options.columns.length; index++) {
            let item = this.options.columns[index];
            if (item.name === this.options.defaultSort.colName) {
              indexO = index + 1;
              break;
            }
          }

          this.order.index_default = indexO;
          this.order.asc_default = asc;

          this.order.index = indexO;
          this.order.asc = asc;

          if (this.options.defaultSort.doSort !== false) {
            setTimeout(() => {
              this.columnSorting(indexO, this.options.defaultSort.colName, asc);
              this.registerHanlink();
              return;
            }, 150);
          }
        }
      }

      this.registerHanlink();

      //難字顯示
      this.reflash = false;
      this.$nextTick(() => {
        this.reflash = true;
      });
      //錨點定位
      if (this.saveData) {
        if (
          this.SavePageData &&
          this.options.scrollLoadingAPI &&
          this.SavePageData.backPage
        ) {
          this.updateSavePageData({ ...this.SavePageData, backPage: false });
          if (this.SavePageData.currentPage > 0) {
            this.options.scrollLoadingAPI(this.SavePageData.currentPage);
          }
          this.$nextTick(() => {
            let scrollSpeed = this.SavePageData.scrollTop / 20 + 700;
            $(".scrollBehavior")
              .stop()
              .animate(
                { scrollTop: this.SavePageData.scrollTop },
                scrollSpeed > 2500 ? 2500 : scrollSpeed,
                "swing"
              );
            this.checkAll = this.SavePageData.checkAll;
            this.checkAllClick = this.SavePageData.checkAllClick;
            this.$emit("update", this.SavePageData.selection);
          });
        }
      }
    },

    //比對全選資料是否一致，一致才將全選打勾
    reChkAllData(tableData, selectionData) {
      try {
        let canCheckedData = tableData.filter((item) => {
          return this.checkboxEnabled(item);
        });

        return (
          canCheckedData.length > 0 &&
          canCheckedData.length == selectionData.length
        );
      } catch {
        return false;
      }
    },
    //顯示更多
    showMore() {
      this.options.showMore(this.is_more);
      this.is_more = !this.is_more;
    },

    scrollmethod(e) {
      this.nowTime = +new Date();
      if (this.nowTime > this.lastTime + 150) {
        this.lastTime = this.nowTime;
        if (
          !this.scrollDataLoading &&
          e.target.scrollTop >
            e.target.scrollHeight - e.target.clientHeight - 200
        ) {
          if (this.options.scrollLoadingAPI) {
            this.options.scrollLoadingAPI();
          }
        }
      }
    },

    columnSorting(index, colName, asc) {
      if (this.order.index === index) {
        this.order.asc = !this.order.asc;
      } else {
        this.order.index = index;
        this.order.asc = true;
      }

      if (asc !== undefined) {
        this.order.asc = asc;
      }
      this.options.sorting(index, colName, this.order.asc);
      if (this.options.columnSortScrollReset) {
        this.$refs.tbody.scrollTop = 0;
      }
    },
    checkboxEnabled(data) {
      if (data) {
        return !(
          data.isShow ||
          data.family_id ||
          (!data.id && !data.ser_no) === ""
        );
      }

      return false;
    },
    birthday2age(item) {
      if (!item || !item.birthday) {
        return "— —";
      }
      computeAge(this.$store.state.userInfo.id, item.birthday).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.$set(item, "age", result.body.age);
          } else {
            return "— —";
          }
        }
      );
    },
    colClick(col, d, did) {
      // 紀錄頁面資訊

      if (col.savePageData) {
        this.updateSavePageData({
          scrollTop:
            this.$refs.tbody.rows[did].offsetTop -
            this.$refs.tbody.rows[did].offsetHeight,
          checkAll: this.checkAll,
          checkAllClick: this.checkAllClick,
          selection: this.selection,
          currentPage: this.currentPage,
          backPage: true,
        });
      }
      col.click(d);
    },
    clearSaveData() {
      this.updateSavePageData({});
    },
  },
  mounted() {
    this.currentWidth =
      this.$el.clientWidth * (this.$el.clientWidth < 1250 ? 0.95 : 1);
    if (this.tableType === "list-area" && !this.is_iPad) {
      this.iPadWidth = "167";
    } else if (this.tableType === "list-area") {
      this.iPadWidth = "150";
    }
    if (this.tableType === "substantial-contact-details" && !this.is_iPad) {
      this.iPadWidth = "97";
    } else if (this.tableType === "substantial-contact-details") {
      this.iPadWidth = "80";
    }
  },
  computed: {
    tdCount() {
      return this.options.columns.length + (this.options.checkAll ? 1 : 0);
    },
    is_iPad() {
      if (/iPad|iPhone|iPod/.test(navigator.platform)) {
        return true;
      } else {
        // 部分 iPadPro 會顯示為 MacIntel
        return (
          navigator.maxTouchPoints &&
          navigator.maxTouchPoints > 2 &&
          /MacIntel/.test(navigator.platform)
        );
      }
    },
    ...mapGetters(["SavePageData"]),
  },
};
</script>

<style lang="scss" scoped>
.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;

  td {
    word-break: break-all;
  }

  &.sorting,
  &.sorting_desc {
    position: relative;
    padding-right: 25px !important;

    &:before,
    &:after {
      content: "";
      position: absolute;
      width: 0px;
      height: 0px;
      display: block;
      top: 0;
      bottom: 0;
      right: 6px;
      margin: auto;
    }

    &:after {
      top: 18px;
      border-top: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &:before {
      top: -13px;
      border-bottom: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid transparent;
    }
  }

  &.sorting_asc:before {
    border-bottom: 6px solid transparentize(white, 0.5);
  }

  &.sorting_desc:after {
    border-top: 6px solid transparentize(white, 0.5);
  }

  &.no-sort:before,
  &.no-sort:after {
    display: none;
  }
}

.newTable tbody.block-height {
  display: block;
  height: 350px;
  overflow-y: scroll;
  overflow-x: hidden;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}
</style>
